module.exports = __webpack_public_path__ + "static/Abacus Data Analyser HR Dashboard-4a102a364d8d70c138dfb53f7c6a5de9.jpg";